export default __webpack_public_path__ + "static/media/alert-error.9c0ab5a4.svg";